
import React, {useState} from 'react';
import classNames from 'classnames';
import {useFAQ} from 'components/Assistant/_FAQ/useFAQ';
import {ChatArea} from 'components/Assistant/ChatArea';
import {ChatSubmit} from 'components/Inputs/ChatSubmit';

import starter from './starter.md';

import * as styles from './styles.module.scss';

export const Dialog = () => {
	const [active, setActive] = useState(false);
	const {state, send} = useFAQ();

	const onSubmit = (v: string) => {
		send(v);
		setActive(true);
	};

	return (
		<div className={classNames({
			[styles.dialog]: true,
			[styles.active]: active,
		})}>
			{active && (
				<div className={styles.messages}>
					<ChatArea state={state} prompt={starter} track='ai:faq' />
				</div>
			)}
			<ChatSubmit onSubmit={onSubmit}>
				Type your question here
			</ChatSubmit>
		</div>
	);
};
